import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "body"]

  toggle(event) {
    const header = event.currentTarget
    const groupId = header.dataset.navSpotlightGroupId
    const body = this.bodyTargets.find(el => el.dataset.navSpotlightGroupId === groupId)

    if (!body) return

    const isOpen = header.getAttribute("aria-expanded") === "true"
    header.setAttribute("aria-expanded", isOpen ? "false" : "true")
    body.classList.toggle("is-open", !isOpen)
  }
}
